export default {"src":"/_next/static/media/preferred_vendor_badge_white.c53da814.svg","height":198,"width":216,"blurWidth":0,"blurHeight":0};